import httpRequest from "../apis/httpRequest";
import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOG_OUT,
  // LOG_OUT_ERROR,
  NO_SESSION,
  LOGIN_URL,
  CHECK_URL,
  LOG_OUT_URL
} from "./types";
import message from "antd/lib/message";

//用户登陆
export const signup = formProps => {
  return dispatch => {
    dispatch({ type: LOGIN_USER });
    const request = httpRequest.post(LOGIN_URL, formProps);
    request
      .then(function (res) {
        // console.log(res);
        dispatch({
          type: LOGIN_SUCCESS,
          payload: res
        });
      })
      .catch(function (err) {
        message.error("用户名或密码出错，请重新输入");
        dispatch({
          type: LOGIN_ERROR,
          payload: "Incorrect Email/Password Combination."
        });
      });
  };
};

//检测登陆
const checkAuth = () => {
  return dispatch => {
    const request = httpRequest.get(CHECK_URL);
    request
      .then(function (res) {
        if (res.data.message !== "no session") {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: res
          });
        } else {
          dispatch({
            type: NO_SESSION,
            payload: "用户未登录"
          });
        }
      })
      .catch(function (err) {
        dispatch({
          type: NO_SESSION,
          payload: "用户未登录"
        });
      });
  };
};
//用户登出
const loginOut = () => {
  return dispatch => {
    const request = httpRequest.get(LOG_OUT_URL);
    request.then(function (res) {
      console.log(res)
      // window.location.replace(res.data.payload)
      dispatch({
        type: LOG_OUT,
        payload: res
      });
    }).catch(err => {
      console.log("err:", err)
      // window.location.reload()
    })
  };
};

export { checkAuth, loginOut };
